import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const ThemeContext = createContext();
const KEY = "samtwo_theme";

function systemTheme() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

function resolve(pref) {
  if (!pref || pref === "system") return systemTheme();
  return pref;
}

function apply(theme) {
  document.documentElement.setAttribute("data-theme", theme);
}

export function ThemeProvider({ children }) {
  const [pref, setPref] = useState(() => localStorage.getItem(KEY) || "dark");
  const [theme, setTheme] = useState(() => resolve(localStorage.getItem(KEY) || "dark"));

  useEffect(() => {
    const t = resolve(pref);
    setTheme(t);
    apply(t);
    if (pref === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, pref);
  }, [pref]);

  // React to OS changes while in "system" mode.
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = () => {
      if ((localStorage.getItem(KEY) || "system") === "system") {
        const t = systemTheme();
        setTheme(t);
        apply(t);
      }
    };
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const toggle = useCallback(() => {
    setPref((p) => (resolve(p) === "dark" ? "light" : "dark"));
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, pref, setPref, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
